import React from 'react';
import { Login } from 'react-admin';
import Box from '@material-ui/core/Box';
import Image from './images/splash.png';
import { makeStyles } from '@material-ui/core';

const loginStyles = makeStyles(theme => ({
    card: {
        marginTop: 0,
        border: '1px'
    },
    main: {
        display: 'flex',
        background: 'white',
        flexDirection: 'column',
        justifyContent: 'center'
    }
}));


const imageStyles = makeStyles(theme => ({
    root: {
        backgroundImage: `url(${Image})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        display: 'flex'
    }
}));

const MyLoginPage = (props) => {
    const loginClass = loginStyles();
    const imageClass = imageStyles();
    return  <Box display="flex">
        <Box flexGrow={1} classes={imageClass}>
        </Box>
        <Box>
            <Login  classes={loginClass} {...props}/>
        </Box>
    </Box>

};

export default MyLoginPage;